var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMessageQuestion = function SvgMessageQuestion(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFA853",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M18.417 19.966h-4.334l-4.82 3.207a1.08 1.08 0 0 1-1.68-.9v-2.307c-3.25 0-5.416-2.167-5.416-5.417v-6.5c0-3.25 2.166-5.416 5.416-5.416h10.834c3.25 0 5.416 2.166 5.416 5.416v6.5c0 3.25-2.166 5.417-5.416 5.417"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFA853",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M13 12.307v-.228c0-.737.455-1.126.91-1.44.444-.304.888-.694.888-1.409 0-.997-.801-1.798-1.798-1.798s-1.798.801-1.798 1.798M12.995 14.895h.01"
  })));
};
export default SvgMessageQuestion;